import React from 'react';
import { Trans, useTranslation } from '../../contexts/translation-context';
import styles from './email-mistype-suggestion-wut.module.scss';
export const EMAIL_MISTYPE_SUGGESTION_DATA_HOOK = 'email-mistype-suggestion';
export const EMAIL_MISTYPE_SUGGESTION_LINK_DATA_HOOK = 'email-mistype-suggestion-link';
const SUGGESTION_KEY = 'input.email.mistype-check.suggestion';
const FIX_ARIA_LABEL_KEY = 'input.email.mistype-check.fix-aria-label';
export const EmailMistypeSuggestionWUT = ({ suggestedEmail, onFix })=>{
    const { t, i18n } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        "data-hook": EMAIL_MISTYPE_SUGGESTION_DATA_HOOK,
        "aria-live": "polite"
    }, suggestedEmail ? /*#__PURE__*/ React.createElement("div", {
        className: styles.suggestion
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18n: i18n,
        t: t,
        i18nKey: SUGGESTION_KEY,
        values: {
            email: suggestedEmail
        },
        components: [
            /*#__PURE__*/ React.createElement("button", {
                key: "0",
                type: "button",
                "data-hook": EMAIL_MISTYPE_SUGGESTION_LINK_DATA_HOOK,
                className: styles.link,
                "aria-label": t(FIX_ARIA_LABEL_KEY, {
                    email: suggestedEmail
                }),
                onClick: onFix
            })
        ]
    })) : null);
};

//# sourceMappingURL=email-mistype-suggestion-wut.js.map